import React, { Component } from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

// import moment from 'moment'
import PropTypes from 'prop-types'
import ReactTable from 'react-table'
import styled from 'styled-components'
import { filterCaseInsensitive } from '../../../util'
import { Button, Form, Popconfirm, Input, Upload, Icon, Tooltip, Spin } from 'antd'

import * as testingSelectors from '../../../selectors/job/testing'
import { actions as testingActions } from '../../../redux/modules/jobFunctions/testingActions'

const { TextArea } = Input

const FilesUploadContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  -webkit-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
`

const EditAttachmentContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`
const EditAttachmentTitle = styled.h6`
  color: #fff;
`
const EditingFileContainer = styled.div`
  margin: 10px 0;
`

const propTypes = {
  selectedTesting: PropTypes.object,

  loadingAttachments: PropTypes.bool,
  attachments: PropTypes.array,
  uploadingAttachment: PropTypes.bool,
  deletingAttachment: PropTypes.bool,

  fetchTestingAttachments: PropTypes.func.isRequired,
  updateAttachmentDescription: PropTypes.func.isRequired,
  deleteTestingAttachment: PropTypes.func.isRequired,
  uploadTestingAttachment: PropTypes.func.isRequired
}

class AddEditModal extends Component {
  state = {
    fileList: [],
    attachmentDetailsVisible: false,
    attachmentName: null,
    attachmentDescription: '',
    attachmentId: null
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  handleEditAttachment = () => {
    const { selectedTesting, updateAttachmentDescription } = this.props
    const { attachmentId, attachmentDescription } = this.state
    updateAttachmentDescription(attachmentId, selectedTesting.id, attachmentDescription)
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  handleAttachmentRowClick = row => {
    this.setState({
      attachmentDetailsVisible: true,
      attachmentId: row.id,
      attachmentName: row.filename,
      attachmentDescription: row.description
    })
  }

  handleAttachmentDelete = event => {
    const { deleteTestingAttachment, selectedTesting } = this.props
    const { attachmentId } = this.state
    deleteTestingAttachment({
      attachmentId: attachmentId,
      testingId: selectedTesting.id
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  handleUploadAttachment = uploadParam => {
    const { uploadTestingAttachment, selectedTesting } = this.props

    const formData = new FormData()

    formData.append('file', uploadParam.file)
    formData.append('type', 'testing')
    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)

    uploadTestingAttachment(formData, selectedTesting.id)
  }

  render() {
    const {
      selectedTesting,
      attachments,
      loadingAttachments,
      deletingAttachment,
      uploadingAttachment
    } = this.props

    const { fileList, attachmentDetailsVisible, attachmentName, attachmentDescription } = this.state

    const uploadPropsOnEdit = {
      multiple: true,
      fileList: fileList
    }

    return (
      <div>
        {selectedTesting && (
          <FilesUploadContainer>
            <div className="row">
              <div className="col-md-6">
                <h5>
                  <Icon type="check" /> Testing Files
                </h5>
              </div>
              <div className="col-md-6 text-right">
                {uploadingAttachment && (
                  <div className="text-success">
                    <Icon type="loading" /> Uploading File(s)
                  </div>
                )}
                {deletingAttachment && (
                  <div className="text-danger">
                    <Icon type="loading" /> Deleting File(s)
                  </div>
                )}
              </div>
            </div>
            {attachments && (
              <Spin spinning={loadingAttachments}>
                <ReactTable
                  defaultPageSize={5}
                  defaultFilterMethod={filterCaseInsensitive}
                  data={attachments}
                  getTrProps={(state, rowInfo, column, instance) => ({
                    onClick: e => this.handleAttachmentRowClick(rowInfo.original)
                  })}
                  columns={[
                    {
                      Header: 'Attached Files',
                      columns: [
                        {
                          Header: 'Filename',
                          id: 'filename',
                          accessor: 'filename',
                          Cell: d => (
                            <Tooltip title={d.original.filename}>{d.original.filename}</Tooltip>
                          )
                        },
                        {
                          Header: 'Description',
                          id: 'description',
                          accessor: d => <Tooltip title={d.description}>{d.description}</Tooltip>
                        },
                        {
                          Cell: row => (
                            <Tooltip placement="left" title="Open this file on a new window">
                              <a target="_blank" href={row.original.signedUrl}>
                                <Icon type="export" className="fontSize20" />
                              </a>
                            </Tooltip>
                          ),
                          maxWidth: 35
                        }
                      ]
                    }
                  ]}
                  defaultSorted={[
                    {
                      id: 'id',
                      desc: true
                    }
                  ]}
                  className="-striped -highlight"
                />
              </Spin>
            )}
            {attachmentDetailsVisible && (
              <EditAttachmentContainer>
                <EditAttachmentTitle>
                  <Icon type="edit" /> Edit Attachment Area
                </EditAttachmentTitle>
                <div>
                  <EditingFileContainer>
                    <Icon type="file" /> {attachmentName}
                  </EditingFileContainer>
                </div>
                <div className="row">
                  <div className="col-md-10">
                    <TextArea
                      placeholder="Describe the attachment..."
                      rows={4}
                      onChange={this.onDescriptionChange}
                      value={attachmentDescription}
                    />
                  </div>
                </div>
                <div className="d-flex flex-row mt-2">
                  <Button onClick={this.handleEditAttachment}>
                    <Icon type="save" /> OK
                  </Button>{' '}
                  <Popconfirm
                    title="Are you sure you want to delete this attachment?"
                    onConfirm={this.handleAttachmentDelete}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button type="danger" icon="delete" className="ml-2">
                      {' '}
                      DELETE
                    </Button>
                  </Popconfirm>
                </div>
              </EditAttachmentContainer>
            )}
            <br />
            <div>Upload Testing File(s)</div>
            <br />
            <Upload {...uploadPropsOnEdit} name="file" customRequest={this.handleUploadAttachment}>
              <Button>
                <Icon type="upload" /> Upload
              </Button>
            </Upload>
          </FilesUploadContainer>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  attachments: testingSelectors.getTestingAttachments(state, props),
  loadingAttachments: testingSelectors.getAttachmentsLoading(state, props),
  uploadingAttachment: testingSelectors.getAttachmentUploading(state, props),
  deletingAttachment: testingSelectors.getAttachmentDeleting(state, props)
})
const mapDispatchToProps = (dispatch, props) => ({
  fetchTestingAttachments: testingId => dispatch(testingActions.fetchTestingAttachments(testingId)),
  updateAttachmentDescription: (attachmentId, testingId, description) =>
    dispatch(
      testingActions.updateTestingAttachmentDescription(attachmentId, testingId, description)
    ),
  deleteTestingAttachment: params => dispatch(testingActions.deleteTestingAttachment(params)),
  uploadTestingAttachment: (formData, testingId) =>
    dispatch(testingActions.uploadTestingAttachment(formData, testingId))
})

AddEditModal.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(AddEditModal)))



// WEBPACK FOOTER //
// ./src/components/jobs/testing/Attachments.js